module.exports = __webpack_public_path__ + "img/frame (249).2d990bb3.jpg";